import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { IOfferComparisonStatus } from '../../types/offer-comparison';

export const comparisonStatus: TComputedPropMapper<IOfferComparisonStatus | null> = ({ offer }) => {
  const { comparisonStatus } = offer;

  return comparisonStatus || null;
};
